import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import HowToDepositModal from './HowToDepositModal'; // Import the modal component
import './Deposit.css';
import { useProfile } from "../context/ProfileContext";
import axios from 'axios';

function Deposit() {
  const navigate = useNavigate();
  const [amount, setAmount] = useState('');
  const [utrNumber, setUtrNumber] = useState('');
  const [selectedMethod, setSelectedMethod] = useState('QR Code'); // Default selection
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [showHowToModal, setShowHowToModal] = useState(false); // State for modal visibility
  const [currentIndex, setCurrentIndex] = useState(0); // Index for carousel
  const { profile } = useProfile();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const quickAmounts = [100,150,200,250,300,350,400, 500];
  const paymentMethods = ['QR Code', 'UPI ID', 'Bank Details'];

  const qrCodes = ['QR1.png', 'QR2.png', 'QR3.png']; // Example QR codes
  // const upiIds = ['upi1@bank', 'upi2@bank', 'upi3@bank']; // Example UPI IDs
  // const bankDetails = [
  //   { name: 'Account 1', number: '1234567890', ifsc: 'BANK0001234' },
  //   { name: 'Account 2', number: '9876543210', ifsc: 'BANK0005678' },
  //   { name: 'Account 3', number: '1122334455', ifsc: 'BANK0009101' },
  // ];

  const [upiIds, setUpiId] = useState("");
  const [bankDetails, setPhone] = useState("");
  // const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/api/getupiqr`)
      .then((response) => {
        setUpiId(response.data.upi_id);
        setPhone(response.data.bank);
        // setQrCode(`${process.env.REACT_APP_BASE_URL}/${response.data.qrCode}`);
        // setQrCode(response.data.qrCode);
      })
      .catch((error) => {
        console.error("Error fetching payment details:", error);
      });
  }, []);

  const handleQuickAmountClick = (value) => {
    setAmount(value);
  };

  const handleMethodClick = (method) => {
    setSelectedMethod(method);
    setCurrentIndex(0); // Reset index when method changes
  };

  const handleScreenshotUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPaymentScreenshot(file);
      console.log('Screenshot selected:', file.name);
    }
  };

  const handleAddMoney = async () => {
    if (!amount || !utrNumber) {
      alert('Please enter amount and UTR number');
      return;
    }
    
    if (!profile?.userId) {
      alert('You must be logged in to deposit money');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Get user data from localStorage
      const userString = localStorage.getItem('user');
      let userData;
      
      try {
        userData = JSON.parse(userString);
      } catch (error) {
        console.error('Error parsing user data:', error);
        alert('Error accessing user account. Please log in again.');
        setIsSubmitting(false);
        return;
      }
      
      const userName = userData?.name || userData?.username || 'N/A';
      const phoneNo = userData?.phoneNumber || 'N/A';
      
      // Prepare form data for API
      const formData = {
        Utr: utrNumber,
        userName: userName,
        user: profile?.userId,
        phoneNumber: phoneNo,
        deposite: amount
      };
      console.log(formData);
      // Send to backend API
      await axios.post(`${process.env.REACT_APP_BASE_URL}/api/add-more-points`, formData);
      
      // Build message with all details for WhatsApp
      let message = `*Deposit Request*\n`;
      message += `*User ID:* ${profile?.userId || 'N/A'}\n`;
      message += `*Name:* ${userName}\n`;
      message += `*Phone:* ${phoneNo}\n`;
      message += `*Amount:* ₹${amount}\n`;
      message += `*Payment Method:* ${selectedMethod}\n`;
      message += `*UTR Number:* ${utrNumber}\n`;
      
      if (selectedMethod === 'QR Code') {
        message += `*QR Code:* ${qrCodes[currentIndex]}\n`;
      } else if (selectedMethod === 'UPI ID') {
        message += `*UPI ID:* ${upiIds[currentIndex]}\n`;
      } else if (selectedMethod === 'Bank Details') {
        message += `*Bank Account:* ${bankDetails[currentIndex].name}\n`;
        message += `*Account Number:* ${bankDetails[currentIndex].number}\n`;
        message += `*IFSC:* ${bankDetails[currentIndex].ifsc}\n`;
      }
      
      message += `*Screenshot:* ${paymentScreenshot ? 'Uploaded' : 'Not uploaded'}\n`;
      
      // Encode message for WhatsApp
      const encodedMessage = encodeURIComponent(message);
      
      // Open WhatsApp with pre-filled message
      window.open(`https://wa.me/919886643666?text=${encodedMessage}`, '_blank');
      
      alert('Deposit request submitted successfully!');
      navigate('/wallet');
    } catch (error) {
      console.error('Error submitting deposit request:', error);
      alert('Failed to submit deposit request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleHowToModal = () => {
    setShowHowToModal(!showHowToModal);
  };

  const handleNext = () => {
    if (selectedMethod === 'QR Code' && currentIndex < qrCodes.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (selectedMethod === 'UPI ID' && currentIndex < upiIds.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else if (selectedMethod === 'Bank Details' && currentIndex < bankDetails.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="deposit-container">
      <div className="deposit-header">
        <button className="back-button" onClick={() => navigate('/wallet')}>← </button>
        <h1>Deposit Funds</h1>
      </div>

      <div className="deposit-content">
        <div className="how-to-deposit">
          <button className="how-to-button" onClick={toggleHowToModal}>
            How to Deposit
          </button>
        </div>

        <div className="amount-section">
          <label htmlFor="amount-input" className="input-label">Enter Amount (₹)</label>
          <input 
            id="amount-input"
            type="number" 
            placeholder="Enter amount" 
            value={amount} 
            onChange={(e) => setAmount(e.target.value)} 
            className="amount-input"
          />
          <div className="quick-amounts-container">
            <div className="quick-amounts-row">
              {quickAmounts.slice(0, 4).map(value => (
                <button 
                  key={value} 
                  onClick={() => handleQuickAmountClick(value)} 
                  className="quick-amount-button"
                >
                  +₹{value}
                </button>
              ))}
            </div>
            <div className="quick-amounts-row">
              {quickAmounts.slice(4).map(value => (
                <button 
                  key={value} 
                  onClick={() => handleQuickAmountClick(value)} 
                  className="quick-amount-button"
                >
                  +₹{value}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="payment-methods">
          {paymentMethods.map(method => (
            <button 
              key={method}
              onClick={() => handleMethodClick(method)}
              className={`method-button ${selectedMethod === method ? 'active' : ''}`}
            >
              {method}
            </button>
          ))}
        </div>

        <div className="payment-details">
          <div className="carousel-controls">
            <button className="left-arrow" onClick={handlePrevious} disabled={currentIndex === 0}>←</button>

            {selectedMethod === 'QR Code' && (
              <div className="qr-code-section">
                <h2>Scan QR Code</h2>
                <div className="qr-code-placeholder">{qrCodes[currentIndex]}</div>
                <p>Scan this QR code to make payment</p>
              </div>
            )}
            {selectedMethod === 'UPI ID' && (
              <div className="upi-details-section">
                <h2>UPI ID Details</h2>
                <p>Pay to: <strong>{upiIds[currentIndex]}</strong> <button className='copy-button'  onClick={() => handleCopy(upiIds[currentIndex])}>📋</button></p>
              </div>
            )}
            {selectedMethod === 'Bank Details' && (
              <div className="bank-details-section">
                <h2>Bank Account Details</h2>
                <p>AC Name: <strong>{bankDetails[currentIndex].name}</strong><button className='copy-button' onClick={() => handleCopy(bankDetails[currentIndex].name)}>📋</button></p>
                <p>AC Number: <strong>{bankDetails[currentIndex].number}</strong> <button className='copy-button'  onClick={() => handleCopy(bankDetails[currentIndex].number)}>📋</button></p>
                <p>IFSC Code: <strong>{bankDetails[currentIndex].ifsc}</strong> <button className='copy-button'  onClick={() => handleCopy(bankDetails[currentIndex].ifsc)}>📋</button></p>
              </div>
            )}

            <button className="right-arrow" onClick={handleNext} 
              disabled={
                (selectedMethod === 'QR Code' && currentIndex === qrCodes.length - 1) ||
                (selectedMethod === 'UPI ID' && currentIndex === upiIds.length - 1) ||
                (selectedMethod === 'Bank Details' && currentIndex === bankDetails.length - 1)
              }
            >→</button>
          </div>
        </div>

        <div className="screenshot-upload-section">
          <label htmlFor="screenshot-upload" className="upload-button">
            Upload Payment Screenshot
          </label>
          <input 
            id="screenshot-upload"
            type="file"
            accept="image/*"
            onChange={handleScreenshotUpload}
            style={{ display: 'none' }}
          />
          {paymentScreenshot && <p className="file-name">Selected: {paymentScreenshot.name}</p>}
        </div>

        <div className="utr-input-section">
          <label htmlFor="utr-input" className="input-label">UTR Number</label>
          <input 
            id="utr-input"
            type="text" 
            placeholder="Enter UTR/Reference Number" 
            value={utrNumber} 
            onChange={(e) => setUtrNumber(e.target.value)} 
            className="utr-input"
          />
        </div>

        <button 
          className="add-money-button" 
          onClick={handleAddMoney}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Processing...' : 'Add Money'}
        </button>
      </div>

      {showHowToModal && <HowToDepositModal onClose={toggleHowToModal} />}
    </div>
  );
}

export default Deposit;
